import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import {
  CancelIcon,
  FirstMaiVisitIcon,
  NoVisitIcon,
  ReadOnlyIcon,
  RevisitIcon,
  SchedulerNotesIcon,
  TimeConstraintsIcon,
} from "v2/components/icons";

import "./DestinationLegend.scss";

const DestinationLegend = (props) => {
  const {className} = {props};
  const classNames = classnames("DestinationLegend", className);

  return (
    <div className={classNames}>
      <FirstMaiVisitIcon showDesc />
      <NoVisitIcon showDesc />
      <RevisitIcon showDesc />
      <SchedulerNotesIcon showDesc />
      <TimeConstraintsIcon showDesc />
      <ReadOnlyIcon showDesc />
      <CancelIcon showDesc />
    </div>
  );
};

DestinationLegend.propTypes = {
  className: PropTypes.string,
};

export default DestinationLegend;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationLegend.js
 **/